import { render, staticRenderFns } from "./facility-unit-count.vue?vue&type=template&id=60606c24&"
import script from "./facility-unit-count.vue?vue&type=script&lang=js&"
export * from "./facility-unit-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60606c24')) {
      api.createRecord('60606c24', component.options)
    } else {
      api.reload('60606c24', component.options)
    }
    module.hot.accept("./facility-unit-count.vue?vue&type=template&id=60606c24&", function () {
      api.rerender('60606c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24fXGZ4EUs7Gy/JS/comp/facility-unit-count.vue"
export default component.exports